import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../api/store";
import { FileRequirement, FileRequirementState } from "./file-requirement.state";

const emptyFile = (id:number): FileRequirement => ({
    file_name: "",
    file_path: "",
    id,
    is_uploaded: false,
    key: "",
    label: "",
});

const initialState: FileRequirementState = {
    fileSignProposalConforme: emptyFile(1),
    fileApplicationForGroupInsurance: emptyFile(2),
    fileDTI: emptyFile(3),
    fileSECCertOfRegist: emptyFile(4),
    fileArticlesOfIncorp: emptyFile(5),
    fileByLaws: emptyFile(6),
    fileBusinessPermit: emptyFile(7),
    fileMasterList: emptyFile(8),
    fileAuthSignId: emptyFile(9),
}

const fileRequirementSlice = createSlice({
    name: "fileRequirementSlice",
    initialState,
    reducers: {
        updateFileRequirements: (state, action: PayloadAction<FileRequirement[]>) => {
            action.payload.forEach((item)=>{
                const file = Object.values(state)
                    .find(
                        requirement => requirement.id === item.id
                    );
                if(file){
                    file.file_name = item.file_name;
                    file.file_path = item.file_path;
                    file.is_uploaded = item.is_uploaded;
                    file.key = item.key;
                    file.label = item.label;
                }
            });
        }
    },
});

export const {
    updateFileRequirements,
} = fileRequirementSlice.actions;

export const selectFileSignProposalConforme = (state: RootState) => state.fileRequirementSlice.fileSignProposalConforme
export const selectFileApplicationForGroupInsurance = (state: RootState) => state.fileRequirementSlice.fileApplicationForGroupInsurance
export const selectFileDTI = (state: RootState) => state.fileRequirementSlice.fileDTI
export const selectFileSECCertOfRegist = (state: RootState) => state.fileRequirementSlice.fileSECCertOfRegist
export const selectFileArticlesOfIncorp = (state: RootState) => state.fileRequirementSlice.fileArticlesOfIncorp
export const selectFileByLaws = (state: RootState) => state.fileRequirementSlice.fileByLaws
export const selectFileBusinessPermit = (state: RootState) => state.fileRequirementSlice.fileBusinessPermit
export const selectFileMasterList = (state: RootState) => state.fileRequirementSlice.fileMasterList
export const selectFileAuthSignId = (state: RootState) => state.fileRequirementSlice.fileAuthSignId

export const selectFileRequirements = (state:RootState)=> state.fileRequirementSlice;

export const selectFileRequirementById = ( state:RootState, id:number)=>{
    return Object.values(state.fileRequirementSlice).find(file => file.id === id);
};

export const selectAllFilesUploaded = (state: RootState) => {
    return Object.values(state.fileRequirementSlice)
        .every(file => file.is_uploaded);
};


export default fileRequirementSlice.reducer;